export default {
  badge: 'نشان',
  open: 'باز کردن',
  close: 'بستن',
  dismiss: 'رد کردن',
  confirmEdit: {
    ok: 'تایید',
    cancel: 'لغو',
  },
  dataIterator: {
    noResultsText: 'نتیجه‌ای یافت نشد',
    loadingText: 'در حال بارگذاری...',
  },
  dataTable: {
    itemsPerPageText: 'ردیف در صفحه:',
    ariaLabel: {
      sortDescending: 'مرتب‌سازی نزولی',
      sortAscending: 'مرتب‌سازی صعودی',
      sortNone: 'بدون مرتب‌سازی',
      activateNone: 'غیرفعال‌سازی مرتب‌سازی',
      activateDescending: 'غیرفعال‌سازی مرتب‌سازی نزولی',
      activateAscending: 'غیرفعال‌سازی مرتب‌سازی صعودی',
    },
    sortBy: 'مرتب‌سازی براساس',
  },
  dataFooter: {
    itemsPerPageText: 'ردیف در صفحه:',
    itemsPerPageAll: 'همه',
    nextPage: 'صفحه‌ی بعد',
    prevPage: 'صفحه‌ی قبل',
    firstPage: 'صفحه‌ی یکم',
    lastPage: 'صفحه‌ی آخر',
    pageText: '{0} تا {1} از {2}',
  },
  dateRangeInput: {
    divider: 'تا',
  },
  datePicker: {
    itemsSelected: '{0} انتخاب‌شده',
    range: {
      title: 'انتخاب تاریخ‌ها',
      header: 'تاریخ‌ها را وارد کنید',
    },
    title: 'انتخاب تاریخ',
    header: 'تاریخ را وارد کنید',
    input: {
      placeholder: 'تاریخ را وارد کنید',
    },
  },
  noDataText: 'داده‌ای موجود نیست',
  carousel: {
    prev: 'اسلاید قبلی',
    next: 'اسلاید بعدی',
    ariaLabel: {
      delimiter: 'اسلاید {0} از {1}',
    },
  },
  calendar: {
    moreEvents: '{بیشتر {0',
    today: 'امروز',
  },
  input: {
    clear: 'پاکسازی {0}',
    prependAction: '{0} prepended action',
    appendAction: '{0} appended action',
    otp: 'لطفا کد را وارد کنید {0}',
  },
  fileInput: {
    counter: '{0} پرونده',
    counterSize: '{0} پرونده ({1} در کل)',
  },
  fileUpload: {
    title: 'Drag and drop files here',
    divider: 'or',
    browse: 'Browse Files',
  },
  timePicker: {
    am: 'قبل از ظهر',
    pm: 'بعد از ظهر',
    title: 'انتخاب زمان',
  },
  pagination: {
    ariaLabel: {
      root: 'جهت یابی صفحه',
      next: 'صفحه‌ی بعد',
      previous: 'صفحه‌ی قبلی',
      page: 'برو صفحه {0}',
      currentPage: '{0} صفحه‌ی فعلی ، صفحه‌ی',
      first: 'صفحه‌ی اول',
      last: 'صفحه‌ی آخر',
    },
  },
  stepper: {
    next: 'بعدی',
    prev: 'قبلی',
  },
  rating: {
    ariaLabel: {
      item: 'امتیاز {0} از {1}',
    },
  },
  loading: 'در حال بارگذاری...',
  infiniteScroll: {
    loadMore: 'بارگذاری بیشتر',
    empty: 'پایان',
  },
}
